import React, { useEffect, useMemo, useRef } from 'react'
import { Form } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectCrossClientPageResults, selectCrossClientSelectedResultIds, setCrossClientPageSelection } from '../../../../store/crossClient/crossClientResults'
import styles from './CrossClientResultSelect.module.scss'

export const CrossClientResultSelectAllHeader: React.FC = () => {
  const dispatch = useAppDispatch()
  const pageResults = useAppSelector(selectCrossClientPageResults)
  const selectedResultIds = useAppSelector(selectCrossClientSelectedResultIds)
  const inputRef = useRef<HTMLInputElement>(null)

  const { allChecked, indeterminate, currentPageIds } = useMemo(() => {
    const ids = pageResults.map((r) => r.id)
    if (!ids.length) {
      return { allChecked: false, indeterminate: false, currentPageIds: ids }
    }
    const selectedSet = new Set(selectedResultIds)
    const selectedCount = ids.reduce((acc, id) => acc + (selectedSet.has(id) ? 1 : 0), 0)
    return {
      allChecked: selectedCount === ids.length,
      indeterminate: selectedCount > 0 && selectedCount < ids.length,
      currentPageIds: ids,
    }
  }, [pageResults, selectedResultIds])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  const handleChange = () => {
    if (!currentPageIds.length) {
      return
    }
    dispatch(setCrossClientPageSelection({ ids: currentPageIds, selected: !allChecked }))
  }

  return (
    <div className={`d-flex justify-content-center align-items-center w-100 ${styles.checkbox}`}>
      <Form.Check
        ref={inputRef}
        type='checkbox'
        aria-label='Select all rows on current page'
        checked={allChecked}
        disabled={!currentPageIds.length}
        onChange={handleChange}
      />
    </div>
  )
}
